export default __webpack_public_path__ + "static/media/sheet_thumb04_breakevenpoint@2x.83826ecd.png";